import { CWJobSearch } from 'wisestep-api';
import { formatDateInDayMonthYearTime } from 'wisestep-base';

import BasicSearchForm from '../../types/IBasicSearchForm';
import ICWJobsAdvanceSearch from '../types/ICWJobsAdvanceSearch';

export default function (values: BasicSearchForm & ICWJobsAdvanceSearch) {
  const todayDate = new Date();
  const lastActiveDate = todayDate.setDate(todayDate.getDate() - Number(values.lastActive));

  const query: CWJobSearch = {
    accountId: values.accountId,
    Page: {
      MaxRecords: values.pageSize,
      Page: values.page,
    },
    Sort: { Descending: values.sortDirection === 'desc' ? true : false, Column: values.sort },
    SearchText: values.query ? values.query : '',
    SearchType: values.searchType && values.searchType,
    SearchOption: values.searchOption && values.searchOption,
    LastActivityDate: formatDateInDayMonthYearTime(new Date(lastActiveDate) + ''),
    Languages: values.languages && values.languages,
    HighestLevelOfEducation: values.highestLevelOfEducation && values.highestLevelOfEducation,
    Countries: values.countries && values.countries,
    workspaceId: values.workspaceId,
    HideCandidatesViewedSince: values.HideCandidatesViewedSince && values.HideCandidatesViewedSince,
  };

  if (values.relocate) {
    if (values.relocate === '1') query.WillingToRelocate = true;
    else query.WillingToRelocate = false;
  }

  if (values?.locations && values?.locations?.length > 0) {
    query.CurrentLocation = values.locations.map((location) => location.id).join(',');
    query.Radius = values.distance ? '' + values.distance : '';
  } else {
    query.Radius = '';
  }

  if (
    values?.salary &&
    values?.salary?.from &&
    values?.salary?.salaryRateType &&
    values?.salary?.to
  ) {
    query.Salary = {};
    query.Salary.SalaryRateType = values.salary.salaryRateType;
    query.Salary.From = values.salary.from;
    query.Salary.To = values.salary.to;
  }

  if (values.jobHours) query.JobHours?.push(values.jobHours);
  return query;
}
